
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandE as ObiOwnShipNoCommandEElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-e.js';
 
 
 

 
 export const ObiOwnShipNoCommandE = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-e',
   elementClass: ObiOwnShipNoCommandEElement,
   events: {
     
   }
  });
 
 